A webhook request in a paginated list.
